import { Stack, Typography, useTheme } from "@mui/material";
import { PropsWithChildren } from "react";
import { SenecFPPTheme } from "@newsenec/ui-components";

export const EnBWScreenTemplate = (props: PropsWithChildren<unknown>) => {
    const theme: SenecFPPTheme = useTheme();
    return (
        <>
            {/* Desktop view */}
            <Stack
                width="100vw"
                minHeight="100vh"
                sx={{
                    display: { xs: "none", md: "flex" },
                    backgroundColor: theme.palette.neutralGray00.main,
                }}
            >
                <Stack
                    alignItems="center"
                    sx={{
                        marginTop: "auto",
                        marginBottom: "auto",
                    }}
                >
                    <Stack
                        alignItems="flex-start"
                        justifyContent="center"
                        spacing="2.5rem"
                        p="2rem"
                        minHeight="60vh"
                        width="33vw"
                        sx={{
                            backgroundColor: theme.palette.white.main,
                            border: "1px solid",
                            borderRadius: "12px",
                            borderColor: theme.palette.neutralGray20.main,
                        }}
                    >
                        <MyEnergyKeyHeader />
                        <SenecLogo />
                        {props.children}
                    </Stack>
                </Stack>
            </Stack>

            {/* Mobile view */}
            <Stack
                height="100vh"
                width="100vw"
                sx={{
                    display: { xs: "flex", md: "none" },
                    backgroundColor: theme.palette.neutralGray00.main,
                }}
            >
                <Stack
                    alignItems="flex-start"
                    spacing="2.5rem"
                    p="1.5rem"
                    flexGrow={1}
                    sx={{ backgroundColor: theme.palette.white.main }}
                >
                    <MyEnergyKeyHeader />
                    <SenecLogo />
                    {props.children}
                </Stack>
            </Stack>
        </>
    );
};

const MyEnergyKeyHeader = () => {
    const theme: SenecFPPTheme = useTheme();
    return (
        <Stack
            direction="row"
            spacing={2}
            height="3rem"
            alignItems="center"
            alignSelf="stretch"
            justifyContent="space-between"
            sx={{ borderBottom: "1px solid", borderColor: theme.palette.neutralGray40.main }}
        >
            <Stack direction="row" alignItems="center">
                <img src="/mek-logo.png" alt="MyEnergyKey Icon" height="12rem" style={{ marginRight: "0.2rem" }} />
                <Stack direction="row">
                    <Typography variant="h5" sx={{ fontWeight: "bold", color: theme.palette.impulseOrange.main }}>
                        my
                    </Typography>
                    <Typography variant="h5" sx={{ fontWeight: "bold", color: theme.palette.deepBlue.main }}>
                        EnergyKey
                    </Typography>
                </Stack>
            </Stack>
            <img src="/logo-mek-enbw.svg" alt="MEK EnBW Logo" height="12rem" />
        </Stack>
    );
};

const SenecLogo = () => {
    return <img src="/senec-logo.png" alt="SENEC Logo" height="25px" />;
};
